export default function isEntityDisabledByServer(entityValue: number): boolean {
    if (entityValue !== null && entityValue !== undefined) {
        // < 0 implies that the server has disabled TXP for the user in some manner
        return entityValue < 0;
    }

    return true;
}
